import Vue from 'vue'
import Router from 'vue-router'
import Register from '../views/register/index'
import List from '../views/list/index'
// import Detail from '../views/detail/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'register',
      component: Register
    },
    {
      path: '/list',
      name: 'list',
      component: List
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js